import * as yup from 'yup';

const DEFAULT_VALUES = {
  isOutOfLoyaltyProgram: false,
  banRemovalDate: null,
  isBanned: false,
  loyaltyProgramJoinDate: null,
};

const BODY_SCHEMA = yup.object({
  isOutOfLoyaltyProgram: yup.boolean(),
  banRemovalDate: yup.date().nullable(),
  isBanned: yup.boolean(),
  loyaltyProgramJoinDate: yup.date().nullable(),
});

type FormData = yup.InferType<typeof BODY_SCHEMA>;

export { DEFAULT_VALUES, BODY_SCHEMA };
export type { FormData };
